import { Rfx } from "../../types/ProjectTypes";
import { safeDELETE, safePUT } from "./SafeClient";

/** Flag the given vendors as SELECTED on the RFx (additive). */
export function selectRfxVendors(
    rfxId: number,
    vendorKeys: string[],
    abort?: any
): Promise<Rfx> {
    return safePUT(
        `/api/rfx/${rfxId}/vendors/selected`,
        { vendorKeys },
        abort
    );
}

/** Flip the given vendors back to CANDIDATE. Rejects vendors with a spawned deal. */
export function unselectRfxVendors(
    rfxId: number,
    vendorKeys: string[],
    abort?: any
): Promise<Rfx> {
    return safeDELETE(
        `/api/rfx/${rfxId}/vendors/selected`,
        { vendorKeys },
        abort
    );
}

/** Set the "vendors were selected" flag on the RFx. */
export function setRfxVendorsSelected(
    rfxId: number,
    value: boolean,
    abort?: any
): Promise<Rfx> {
    return safePUT(
        `/api/rfx/${rfxId}/vendors-selected`,
        { value },
        abort
    );
}
